import { useEffect, useState } from 'react';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import cn from 'classnames';
import * as React from 'react';
import Button from '@cvent/carina/components/Button';
import { RoomItemProps } from '@weddingspot/ws-api-client';

interface SocialTableRoomData {
    socialtablesRoomName: string;
    basicFloorPlanFlag: boolean;
    basicFloorPlanImageUrlSmall: string;
    basicFloorPlanImageUrlLarge: string;
    basicFloorPlanPdfUrl: string;
}

interface MeetingRoomData {
    socialTables?: SocialTableRoomData;
}

export interface FloorPlansData {
    meetingRooms?: MeetingRoomData[];
}

import styles from './styles.module.scss';
import { VenueProfileContext } from '../../context';

function RoomItem(props: RoomItemProps) {
    const onClickHandle = () => {
        logEvent(AnalyticsEvent.EVTNM_FLOOR_PLANS_DOWNLOAD, { Source: 'Wedding venue profile' });
    };

    return (
        <div className={styles.room}>
            <img src={props.socialTables.basicFloorPlanImageUrlSmall} alt={props.name} />
            <h3 className={styles.roomName}>{props.name}</h3>
            <div className={styles.roomHover}>
                {props.socialTables.basicFloorPlanPdfUrl && (
                    <a href={props.socialTables.basicFloorPlanPdfUrl} className={styles.downloadButton} onClick={onClickHandle}>
                        Download PDF
                    </a>
                )}
            </div>
        </div>
    );
}

const FloorPlans = () => {
    const [showSection, setShowSection] = useState(false);
    const [roomsData, setRoomsData] = useState<RoomItemProps[]>();
    const [showAllPlans, setShowAllPlans] = useState(false);
    const { csnVenueProfile, venueId } = React.useContext(VenueProfileContext);

    useEffect(() => {
        const roomsData: RoomItemProps[] = csnVenueProfile.meetingRooms
            ?.filter((room) => !!room.socialTables)
            .map((room) => ({
                name: room.name,
                socialTables: room.socialTables
        }) as RoomItemProps) || [];

        if (roomsData?.length) {
            setRoomsData(roomsData);
            setShowSection(true);

            logEvent(AnalyticsEvent.EVTNM_SOCIAL_TABLES_FLOOR_PLANS_SECTION, {
                Source: 'Venue Profile V3',
                'Venue ID': venueId,
            });
        }
    }, [csnVenueProfile]);

    return showSection ? (
        <>
            <h2>Floor Plans</h2>
            <div
                className={cn(styles.FloorPlans, {
                    [styles.expanded]: showAllPlans,
                    [styles.expandableOnMobile]: roomsData?.length! > 2,
                    [styles.expandableOnDesktop]: roomsData?.length! > 3,
                })}
            >
                {roomsData?.map((room, i) => (
                    <RoomItem key={i} {...room} />
                ))}
                <div className={styles.showAllWrapper}>
                    <Button
                        text='Show All'
                        appearance='lined'
                        isPill={true}
                        onClick={() => {
                            setShowAllPlans(!showAllPlans);
                        }}
                    />
                </div>
            </div>
            <div className='VenuePage--additional-details-separator' />
        </>
    ) : null;
};

export default FloorPlans;
